import { useAllDevices } from './useAllDevices';

/**
 * Use redux to get and fetch device
 * @param deviceId usually is the queryParam
 * @param onError callback when call fail
 * @returns
 */
export const useDevice = (deviceId = '') => {
  const { data: devices, ...rest } = useAllDevices();
  const deviceData = devices?.entities.devices?.[deviceId];
  return { data: deviceData, ...rest };
};
